let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k71Fj")).then(() => parcelRequire('729bR'));